import WorkerRequests from './WorkerRequests';

export default WorkerRequests;
